// @ts-strict-ignore
import React from 'react';
import { DropdownMenu, Tooltip } from '@usealloy/component-library';

interface NodeDropdownItemProps {
  onSelect?(e: Event): void;
  children: React.ReactNode;
  style?: React.CSSProperties;
  disabled: boolean;
  tooltipContent?: string;
  dataId?: string;
}

export default function NodeDropdownItem({
  children,
  onSelect,
  style,
  disabled = false,
  tooltipContent,
  dataId,
}: NodeDropdownItemProps) {
  const DropdownItem = (
    <DropdownMenu.Item
      disabled={disabled}
      onSelect={e => {
        e.stopPropagation();
        onSelect(e);
      }}
      onClick={e => e.stopPropagation()}
      style={style}
      data-dd-action-name={dataId}
    >
      {children}
    </DropdownMenu.Item>
  );

  return tooltipContent ? (
    <Tooltip
      content={tooltipContent}
      style={{ zIndex: 'calc(var(--cl-zindex-tooltip) + 1)' }}
    >
      {DropdownItem}
    </Tooltip>
  ) : DropdownItem;
}
